import {HttpClient} from "../../service/httpClient/HttpClient";
import {convertPersianDateToUniversalDate} from "@moeindal/base-raiko-panel-components";

export class LoanInstallmentsService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getInstallments(fundID, page, size, groupName, groupCode, payStatus, accountCode, endDate) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/installments`,
                {
                    page, size,
                    'paid-status': payStatus !== "ALL" ? payStatus : null,
                    'end-date': endDate && endDate.length > 0 ? convertPersianDateToUniversalDate(endDate) : null,
                    groupCode,
                    'group-name': groupName,
                    'deposit-account-number': accountCode
                }
            ).then(resolve).catch(reject)
        })
    }

    getLoanInstallments(fundID, group, date, type) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/groups/${group}/installments/from-date/${date}`,
                {
                    "includes-monthly-deposit": type
                }
            ).then(resolve).catch(reject)
        })
    }

    updateLoanInstallments(fundID, payList, isTypeB = false) {
        let request = isTypeB ?
            this.httpClient.put(
                `funds/${fundID}/installments/kinds/with-monthly-deposit/submit-paid`,
                payList
            ) :
            this.httpClient.put(
                `funds/${fundID}/installments/kinds/normal/submit-paid`,
                payList
            )


        return new Promise((resolve, reject) => {
            request.then(resolve).catch(reject)
        })
    }
}